import React from 'react';
import { Navigation } from '../Navigation';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';

const StyledHeader = styled.div`
  display: flex;
  box-sizing: border-box;
  padding-top: 20px;
  animation: lowerHeaderIn ease 1s;
  position: relative;
`;

const StyledLogoWrapper = styled.h1`
  margin: 0;
`;

const Header = () => {
  const siteInfo = useStaticQuery(
    graphql`
      query storiTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
        storiThemeData {
          basePath
          siteTitle
        }
      }
    `
  );

  const { title } = siteInfo.site.siteMetadata;
  const { basePath, siteTitle } = siteInfo.storiThemeData;
  return (
    <StyledHeader>
      <StyledLogoWrapper>
        <Link to={basePath}>{siteTitle ? siteTitle : title}</Link>
      </StyledLogoWrapper>
      <Navigation />
    </StyledHeader>
  );
};

export default Header;
